import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-manage-preview-action-button',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule
  ],
  templateUrl: './manage-preview-action-button.component.html',
  styleUrl: './manage-preview-action-button.component.scss',
  host: {
    class: 'contents'
  }
})
export class ManagePreviewActionButtonComponent {
  @Input() icon: string = '';
  @Input() tooltip: string = '';
  @Input() disabled: boolean = false;
  @Input() buttonClass: string = '';

  @Input() tooltipPosition:
    | 'left'
    | 'right'
    | 'above'
    | 'below'
    | 'before'
    | 'after' = 'above';

  @Output() actionClick = new EventEmitter<void>();

  handleClick(): void {
    if (this.disabled) {
      return;
    }

    this.actionClick.emit();
  }
}